import { combineReducers } from 'redux';

import { RouterState, AppAction } from '../types';

import {
  setRouterDefaultRedirectPath,
  setRouterPreventRedirect,
  setRouterPreviousPath,
  setRouterRedirectPath,
} from '../actions';

const defaultRedirectPath = (state = '', action: AppAction) => {
  switch (action.type) {
    case setRouterDefaultRedirectPath.type:
      return action.payload;

    default:
      return state;
  }
};

const redirectPath = (state = '', action: AppAction) => {
  switch (action.type) {
    case setRouterRedirectPath.type:
      return action.payload;

    default:
      return state;
  }
};

const previousPath = (state = '', action: AppAction) => {
  switch (action.type) {
    case setRouterPreviousPath.type:
      return action.payload;

    default:
      return state;
  }
};

const preventRedirect = (state = false, action: AppAction) => {
  switch (action.type) {
    case setRouterPreventRedirect.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers<RouterState>({
  defaultRedirectPath,
  redirectPath,
  previousPath,
  preventRedirect,
});
